import { addSearchToLaneHistory, createLaneHistory } from '../domain/LaneHistory'
import { type PreferredLane, getPreferredLaneKey } from '../domain/PreferredLane'
import { type LaneHistoryRepository } from '../infra/LaneHistoryRepository'

export type AddSearchToLaneHistory = (preferredLane: PreferredLane) => Promise<void>

export type AddSearchToLaneHistoryDependencies = {
  laneHistoryRepository: LaneHistoryRepository
}

export function addSearchToLaneHistoryFactory({
  laneHistoryRepository,
}: AddSearchToLaneHistoryDependencies): AddSearchToLaneHistory {
  return async function addSearchToLaneHistoryUseCase(preferredLane: PreferredLane): Promise<void> {
    try {
      const key = getPreferredLaneKey(preferredLane)
      let laneHistory =
        (await laneHistoryRepository.getById(key)) ?? createLaneHistory(preferredLane)

      laneHistory = addSearchToLaneHistory(laneHistory)

      return laneHistoryRepository.upsert(key, laneHistory)
    } catch (error) {
      throw new Error('Failed to add Search to Lane history', { cause: error as Error })
    }
  }
}
